import PropTypes from 'prop-types';
import {Message, Popup} from 'semantic-ui-react';

import GroupSearch from '../AuthSearch/GroupSearch';

import styles from './GroupSearchField.module.scss';

const GroupSearchField = ({
  id,
  name,
  value,
  onChange,
  error,
  showRecommendation,
  recommendationMessage,
  disablePopup,
  disabled,
}) => {
  return (
    <div className={styles.AdminGroupField}>
      <Popup
        trigger={
          <GroupSearch
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            error={error}
            disabled={disabled}
            label={{
              htmlFor: id,
              className: styles.VisuallyHidden,
              children: 'Administrator group for the site, e.g. my-group',
            }}
            placeholder="Administrator group for the site, e.g. my-group"
            clearable
          />
        }
        position="left center"
        disabled={disablePopup}
      >
        <Popup.Content>
          A group with site management permissions identical to those of site owner. Only CERN
          primary or service accounts group members are considered administrators. Defining an admin
          group enables multiple persons to receive important communication and be able to
          administrate the project.
        </Popup.Content>
      </Popup>
      <Message
        className={styles.AdminGroupFieldMessage}
        size="tiny"
        attached="bottom"
        visible={showRecommendation}
        warning
      >
        <Message.Content>
          {recommendationMessage ? (
            recommendationMessage
          ) : (
            <>
              Setting administrator group for Official sites is strongly recommended. If you do not
              set an admin group now, please make sure to set it at the earliest opportunity.
            </>
          )}
        </Message.Content>
      </Message>
    </div>
  );
};

GroupSearchField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  showRecommendation: PropTypes.bool,
  recommendationMessage: PropTypes.string,
  disablePopup: PropTypes.bool,
  disabled: PropTypes.bool,
};

GroupSearchField.defaultProps = {
  error: null,
  showRecommendation: false,
  recommendationMessage: null,
  disablePopup: false,
  disabled: false,
};

export default GroupSearchField;
